<div class="amway-header-creator-area"
  [ngClass]="{'visible-desktop' : (applyVDClass)}">
  <div class="amway-header-creator-container">
    <div class="amway-header-creator-main">
      <div class="amway-header-creator-left">
        <a class="amway-logo-icon-creator"
          aria-label="amway logo"
          (click)="viewLandingPage()"></a>
      </div>
      <div class="amway-header-creator-right">
        <a *ngIf="(isShopOwnerRole$ | async)===true  && (showHomeIcon)"
          class="shop-list-btn-home"
          (click)="gotoSF()">
        </a>
        <a class="amway-header-creator-cart "
          [ngClass]="{'on-has-login':(isUserLoggedIn$ | async) === true}"
          *ngIf="(isShopOwnerRole$ | async)===false && (showCartIcon)"
          (click)="viewCartPage()">
          <div class="amway-header-creator-cart-count">
            {{(cartItemCount$ | async)}}
          </div>
        </a>
        <a class="amway-header-creator-non-login"
          *ngIf="(isUserLoggedIn$ | async) === false && (hideLoginIcon$ | async)===false"
          (click)="loginUser()">
        </a>
        <app-header-user-info *ngIf="(isUserLoggedIn$ | async) === true &&  (hideUserInfo$ | async)===false"
          [firstName]="loggedInUserFirstName"
          [fullName]="loggedInUserfullName"></app-header-user-info>
        <app-language-dropdown></app-language-dropdown>
      </div>
    </div>
  </div>
</div>
